module.exports = __webpack_public_path__ + "img/udinese-logo-icon.3d38dfc7.png";